import { render, staticRenderFns } from "./SetProvince.vue?vue&type=template&id=099c5a27&"
import script from "./SetProvince.vue?vue&type=script&lang=js&"
export * from "./SetProvince.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports